import { goldBanner } from '@assets/png/imagesPng';
import navigationConstants from '@navigation/navigationConstants';
import { useNavigation } from '@react-navigation/native';
import colors from '@theme/colors';
import { View, Text, Divider } from 'native-base';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image, Pressable } from 'react-native';
import styles from './styles';

function ProfileReferral(props) {
  const { t } = useTranslation('common');
  const navigation = useNavigation();
  const { showReferral } = props;
  if (showReferral) {
    return (
      <>
        <View marginX="16px" marginY="16px">
          <Text testID="txtReferralHeader" variant="md-bold">
            {t('profile.referralHeader')}
          </Text>
          <Pressable
            testID="goldBanner"
            style={styles.goldBanner}
            onPress={() => navigation.navigate(navigationConstants.Finansial)}>
            <Image source={goldBanner} style={styles.goldImage} resizeMode="contain" />
          </Pressable>
        </View>
        <Divider height="4px" style={{ backgroundColor: colors.neutral.mist }} />
      </>
    );
  }
  return null;
}

ProfileReferral.propTypes = {
  showReferral: PropTypes.bool,
};
ProfileReferral.defaultProps = {
  showReferral: false,
};

export default ProfileReferral;
